export default __webpack_public_path__ + "static/media/store.6e3341fb.svg";